@let showControls = $showControls();
@let hideControlCss = showControls ? '' : 'hide-controls';
<kendo-daterange class="daterange">
  <kendo-stacklayout [orientation]="$orientation()">
    @let startControl = $startControl();
    <unity-control-wrapper
      [control]="startControl"
      [description]="$startDescription()"
      [displayName]="$startDisplayName()"
      [showHint]="$showHint()">
      <kendo-dateinput
        kendoDateRangeStartInput
        [class]="hideControlCss"
        [formControl]="startControl"
        [clearButton]="showControls"
        [readonly]="!showControls"
        [title]="startControl.value" />
    </unity-control-wrapper>
    @let endControl = $endControl();
    <unity-control-wrapper
      [control]="endControl"
      [description]="$endDescription()"
      [displayName]="$endDisplayName()"
      [showHint]="$showHint()">
      <kendo-dateinput
        kendoDateRangeEndInput
        placeholder="(none)"
        [class]="hideControlCss"
        [formControl]="endControl"
        [clearButton]="showControls"
        [readonly]="!showControls"
        [title]="endControl.value" />
    </unity-control-wrapper>
  </kendo-stacklayout>
</kendo-daterange>
